import React, { useState } from 'react';
import { Button, Icon, Modal } from 'antd';

export const BtnArchieveOrder = ({ onClick }) => {
  const [visibleModal, setVisibleModal] = useState(false);
  const closeModal = () => {
    setVisibleModal(false);
  };
  const showModal = () => {
    setVisibleModal(true);
  };
  const formSubmit = status => {
    closeModal();
    onClick(status);
  };
  return (
    <>
      <Button
        className="orders-create__edit-btn"
        type="danger"
        ghost
        size="large"
        onClick={showModal}
      >
        Отменить заказ
      </Button>
      <Modal
        visible={visibleModal}
        title={
          <div>
            <Icon style={{ color: '#9b9b9b' }} type="question-circle" />
            Внимание!
          </div>
        }
        onCancel={closeModal}
        className="modal-template-order save"
        centered={true}
        footer={[
          <Button key="cancel" type="primary" ghost onClick={closeModal}>
            Отмена
          </Button>,
          <Button
            key="template"
            type="danger"
            ghost
            onClick={() => formSubmit('archivecarrier')}
          >
            Одностор. отказ
          </Button>,
          <Button
            key="submit"
            type="danger"
            ghost
            onClick={() => formSubmit('archagreement')}
          >
            Отказ по согл. сторон
          </Button>,
        ]}
      >
        <p>
          Отмена заказа приведет к расторжению договора. Вы можете расторгнуть
          договор в одностороннем порядке или по соглашению сторон.
        </p>

        <p>
          Расторжение договора по соглашению сторон требует подтверждения
          (согласия) заказчика (фрахтователя). Без подтверждения договор не
          является расторгнутым.
        </p>
      </Modal>
    </>
  );
};
